import React from 'react'

const Button = ({
  label,
  children,
  color = 'green',
  size = 'small',
  type = 'button',
  className = '',
  onClick,
  ...restProps
}) => {
  return (
    <button
      className={`cp-button color-${color} size-${size} ${className}`}
      // eslint-disable-next-line react/button-has-type
      type={type}
      {...restProps}
      onClick={onClick}
    >
      {label || children}
    </button>
  )
}

export default Button
